import { useAvailablePaymentMethods, usePromoteFormState } from '../../../formContext';
import { useContainer } from '../useContainer';

type Result = ModelHookResult<{
	displayed: boolean;
}>;

export function useFooterContainer(): Result {
	const {
		data: { displayed },
	} = useContainer();

	const { paymentMethods } = useAvailablePaymentMethods();

	const [{ moreWaysExpanded }] = usePromoteFormState();

	const stripeWalletPaymentsEnabled = paymentMethods.includes('applePay') || paymentMethods.includes('googlePay');

	if (stripeWalletPaymentsEnabled) {
		return {
			data: {
				displayed,
			},
		};
	}

	return {
		data: {
			displayed: displayed && moreWaysExpanded,
		},
	};
}
